"use client";

import { ReactPortal, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ResumeInPostPage from "./ResumeInPostPage";

const InjectResume = () => {
  const [nodes, setNodes] = useState<ReactPortal[]>([]);

  useEffect(() => {
    const resumePortalList: ReactPortal[] = [];
    const resumeTags = document.getElementsByTagName("resume");

    for (let index = 0; index < resumeTags.length; index++) {
      const resumeTag = resumeTags[index];
      const hasInjected = resumeTag.getAttribute("injected");
      const resumeId = resumeTag.getAttribute("id");
      if (hasInjected === "true" || !resumeId) continue;
      resumeTag.setAttribute("injected", "true");
      resumePortalList.push(
        createPortal(<ResumeInPostPage id={resumeId} />, resumeTag, resumeId),
      );
    }

    if (resumePortalList.length === 0) return;
    setNodes(resumePortalList);
  }, []);

  return <>{nodes}</>;
};

export default InjectResume;
